"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALERT_MESSAGE = void 0;
var react_1 = __importDefault(require("react"));
var mobx_1 = require("mobx");
var abstract_component_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/abstract_component_store"));
var sns_button_list_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/sns_button_list_store"));
var hidden_form_input_list_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/hidden_form_input_list_store"));
var alert_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/alert_store"));
var google_analytics_manager_1 = __importDefault(require("@hikakaku/shared/util/google_analytics_manager"));
var input_store_factory_1 = require("@hikakaku/shared/stores/estimate_form/common/input/input_store_factory");
var sms_verification_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/sms_verification_store"));
exports.ALERT_MESSAGE = '必須項目を入力してください';
var WATCH_POST_URL = '/estimate_form/watch/thanks';
var WATCH_URL = /^\/(estimate_form\/watch|lp\/watch(\/(rolex\/c3|seiko|omega)?)?)$/;
var INPUT_COMPLETE_GA_EVENT_ENABLED_INPUT_TYPES = [
    input_store_factory_1.InputType.EMAIL,
    input_store_factory_1.InputType.NUMBER,
    input_store_factory_1.InputType.SELECT,
    input_store_factory_1.InputType.TEL,
    input_store_factory_1.InputType.TEXT,
    input_store_factory_1.InputType.TEXTAREA,
    input_store_factory_1.InputType.RADIO,
    input_store_factory_1.InputType.CHECKBOX
];
var AbstractContainerStore = /** @class */ (function (_super) {
    __extends(AbstractContainerStore, _super);
    function AbstractContainerStore(props) {
        var _this = _super.call(this) || this;
        _this.formRef = react_1.default.createRef();
        _this.pageStores = [];
        _this.currentPage = 0;
        _this.isLoading = false;
        _this.isSending = false;
        _this.isModalOpen = false;
        _this.handleClickNextPageButton = function () {
            _this.alertStore.clear();
            _this.currentPage = Math.min(_this.currentPage + 1, _this.pageStores.length - 1);
        };
        _this.handleClickPrevPageButton = function () {
            _this.currentPage = Math.max(_this.currentPage - 1, 0);
        };
        // Modal methods
        _this.handleModalButtonCLick = function () {
            var _a;
            (_a = _this.modalOnClickButton) === null || _a === void 0 ? void 0 : _a.call(_this);
        };
        _this.handleModalClose = function () {
            _this.isModalOpen = false;
        };
        _this.showModal = function (onClickButton) {
            onClickButton && (_this.modalOnClickButton = onClickButton);
            _this.isModalOpen = true;
        };
        _this.handleClickSubmitButton = function (event) { return __awaiter(_this, void 0, Promise, function () {
            var path, phoneInput, phoneNumber, isAlreadyVerified;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        path = typeof window !== 'undefined' ? window.location.pathname.replace(/\/$/, '') : '';
                        if (path.match(WATCH_URL)) {
                            event.target.formAction = WATCH_POST_URL;
                        }
                        if (this.isSending) {
                            event.preventDefault();
                            return [2 /*return*/];
                        }
                        if (!this.validate()) {
                            event.preventDefault();
                            this.alertStore.alertText = exports.ALERT_MESSAGE;
                            this.formRef.current && this.formRef.current.scrollIntoView(true);
                            this.gaEventCategory && google_analytics_manager_1.default.postGAEvent(this.gaEventCategory, 'error', '個人情報入力エラー');
                            return [2 /*return*/];
                        }
                        phoneInput = (_a = this.formRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('input[name*="[tel]"], input[name*="[telephone]"], input[name*="tel"], input[name*="telephone"], input[type="tel"]');
                        phoneNumber = (_b = phoneInput === null || phoneInput === void 0 ? void 0 : phoneInput.value) === null || _b === void 0 ? void 0 : _b.trim();
                        if (!phoneNumber) return [3 /*break*/, 3];
                        event.preventDefault();
                        this.smsVerificationStore.phoneNumber = phoneNumber;
                        if (!!this.smsVerificationStore.otpRequested) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.checkSmsVerification(phoneNumber)];
                    case 1:
                        isAlreadyVerified = _c.sent();
                        if (isAlreadyVerified) {
                            // Phone is already verified, submit form directly
                            this.submitFormWithSmsToken();
                            return [2 /*return*/];
                        }
                        _c.label = 2;
                    case 2:
                        // Phone not verified or SMS already sent, open modal for verification
                        this.smsVerificationStore.isModalOpen = true;
                        return [3 /*break*/, 4];
                    case 3:
                        // No phone number, proceed with normal submission
                        this.isSending = true;
                        this.removeBeforeUnloadEvent();
                        _c.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.checkSmsVerification = function (phoneNumber) { return __awaiter(_this, void 0, Promise, function () {
            var success;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.smsVerificationStore.sendCode(phoneNumber)];
                    case 1:
                        success = _a.sent();
                        return [2 /*return*/, success && this.smsVerificationStore.isVerified];
                }
            });
        }); };
        _this.submitFormWithSmsToken = function () {
            // Add SMS verification token to hidden fields
            if (_this.smsVerificationStore.token && _this.hiddenFieldInputListStore) {
                _this.hiddenFieldInputListStore.replaceHiddenField({
                    name: 'estimate_form[sms_verification_token]',
                    value: _this.smsVerificationStore.token
                });
            }
            // Submit the form
            if (_this.formRef.current) {
                _this.isSending = true;
                _this.removeBeforeUnloadEvent();
                _this.formRef.current.submit();
            }
        };
        _this.handleClickSnsLoginButton = function () {
            if (typeof window !== 'undefined') {
                var path = window.location.pathname + window.location.search;
                document.cookie = "redirect_path_before_oauth=".concat(encodeURIComponent(path), "; path=/; max-age=600");
            }
            _this.saveDraft();
            _this.removeBeforeUnloadEvent();
        };
        _this.removeBeforeUnloadEvent = function () {
            window.removeEventListener('beforeunload', _this.handleBeforeUnload, false);
        };
        _this.assignInputCompleteGAEvent = function (props) {
            return props.map(function (props) { return (INPUT_COMPLETE_GA_EVENT_ENABLED_INPUT_TYPES.includes(props.type)
                ? (__assign(__assign({}, props), { onBlur: function (value) {
                        if (value && _this.gaEventCategory) {
                            google_analytics_manager_1.default.postGAEvent(_this.gaEventCategory, props.necessary ? 'input' : 'input_free', props.label);
                        }
                    } })) : (props)); });
        };
        _this.assignDropzoneGAEvent = function (props) {
            return props.map(function (props) { return (props.type === input_store_factory_1.InputType.PHOTOS
                ? (__assign(__assign({}, props), { onChangeDropzone: function (value) {
                        if (value && _this.gaEventCategory) {
                            google_analytics_manager_1.default.postGAEvent(_this.gaEventCategory, 'click', '画像アップロード');
                        }
                    } })) : (props)); });
        };
        _this.handleChangePage = function () {
            _this.pageStores.forEach(function (store, idx) {
                store.isActive = _this.currentPage === idx;
            });
            _this.formRef.current && _this.formRef.current.scrollIntoView(true);
        };
        _this.handleBeforeUnload = function (event) {
            _this.saveDraft();
            if (_this.props.noAlert) {
                return;
            }
            event.returnValue = '';
        };
        (0, mobx_1.reaction)(function () { return _this.pageStores; }, _this.handleChangePage);
        (0, mobx_1.reaction)(function () { return _this.currentPage; }, _this.handleChangePage);
        _this.props = props;
        _this.alertStore = new alert_store_1.default({ text: props.alertMessage || undefined });
        _this.hiddenFieldInputListStore = new hidden_form_input_list_store_1.default({});
        _this.smsVerificationStore = new sms_verification_store_1.default({});
        _this.snsButtonListStore = new sns_button_list_store_1.default({
            enabled: !props.isUserSignedIn && !props.noSnsButton,
            authenticityToken: props.authenticityToken,
            googleOAuthPathBase: props.googleOauthPathBase,
            lineOAuthPathBase: props.lineOauthPathBase,
            onClickButton: _this.handleClickSnsLoginButton
        });
        _this.gaEventCategory = props.gaEventCategory || undefined;
        _this.kaitoriBonusCampaignId = props.kaitoriBonusCampaignId;
        if (props.kaitoriBonusCampaignId) {
            _this.hiddenFieldInputListStore.addHiddenField({
                name: 'estimate_form[kaitori_bonus_campaign_id]',
                value: String(props.kaitoriBonusCampaignId)
            });
        }
        _this.currentPage = props.pageNumber - 1;
        _this.fixedComponentStores = [_this.hiddenFieldInputListStore];
        if (typeof window !== 'undefined') {
            window.addEventListener('beforeunload', _this.handleBeforeUnload, false);
        }
        // Disable submit buttons when SMS modal is open
        (0, mobx_1.reaction)(function () { return _this.smsVerificationStore.isModalOpen; }, function (isOpen) {
            _this.updateSubmitButtonsDisabled(isOpen);
        });
        return _this;
    }
    AbstractContainerStore.prototype.assignInputGAEvent = function (props) {
        return this.assignInputCompleteGAEvent(this.assignDropzoneGAEvent(props));
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AbstractContainerStore.prototype, "formRef", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], AbstractContainerStore.prototype, "fixedComponentStores", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], AbstractContainerStore.prototype, "pageStores", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AbstractContainerStore.prototype, "currentPage", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AbstractContainerStore.prototype, "isLoading", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AbstractContainerStore.prototype, "isSending", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AbstractContainerStore.prototype, "isModalOpen", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], AbstractContainerStore.prototype, "gaEventCategory", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AbstractContainerStore.prototype, "kaitoriBonusCampaignId", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AbstractContainerStore.prototype, "handleClickNextPageButton", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AbstractContainerStore.prototype, "handleClickPrevPageButton", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AbstractContainerStore.prototype, "handleModalButtonCLick", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AbstractContainerStore.prototype, "handleModalClose", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AbstractContainerStore.prototype, "showModal", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AbstractContainerStore.prototype, "checkSmsVerification", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AbstractContainerStore.prototype, "submitFormWithSmsToken", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AbstractContainerStore.prototype, "handleChangePage", void 0);
    return AbstractContainerStore;
}(abstract_component_store_1.default));
exports.default = AbstractContainerStore;
